import { formatToTwoDPIfAnyDP } from '../../utils/utils';

export const BookingExtraCheckbox = ({
  id,
  item,
  price,
  checked,
  onChange,
  disabled,
  ariaLabel,
  showDivider = true,
}) => {
  const handleChange = onChange && !disabled ? () => onChange(!checked) : undefined;
  const cursorClass = disabled ? 'cursor-disabled' : 'cursor-pointer';

  return (
    <>
      {showDivider && <hr className="my-2 w-100" />}
      <label className={`d-flex align-items-center gap-1 ${cursorClass}`} htmlFor={id}>
        <input
          type="checkbox"
          id={id}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          aria-label={ariaLabel}
        />
        Yes, I want {item.toLowerCase()}: <strong>£{formatToTwoDPIfAnyDP(price)}</strong>
      </label>
    </>
  );
};
